import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ConfigT, Web3ConfigStateT } from "types";

export const initialweb3ConfigState: Web3ConfigStateT = {
  config: null
};

const web3ConfigSlice = createSlice({
  name: 'web3Config',
  initialState: initialweb3ConfigState,
  reducers: {
    setConfig(state, action: PayloadAction<ConfigT>) {
      state.config = action.payload;
    },
  },
});

export const {
  setConfig,
} = web3ConfigSlice.actions;

export default web3ConfigSlice.reducer;